export default __webpack_public_path__ + "60d6ef9bf1c6574373e8cb43e0468bcb.png";